import React from "react";
import { color } from "@ui";
import { css } from "@linaria/core";
import { spacings } from "@ui/Theme";
import Text from "@ui/Text";
import { MAX_PROCESS_INDICATOR_COUNT } from "diagnostics-domain/quantity/processIndicator";
const IndicatorsDisplay = ({
  indicators,
}: {
  indicators: { name: string; measured: number | null; unit: string }[];
}) => {
  const displayedIndicators = React.useMemo(
    () => indicators.slice(0, MAX_PROCESS_INDICATOR_COUNT),
    [indicators],
  );
  if (displayedIndicators.length === 0) return null;

  return (
    <div className={IndicatorsWrapper}>
      {displayedIndicators.map(indicator => (
        <React.Fragment key={indicator.name}>
          <div className={IndicatorContainer}>
            <Text type="body2" className={IndicatorName} title={indicator.name}>
              {indicator.name}
            </Text>
            <div className={IndicatorValueContainer}>
              <Text type="body2" className={IndicatorValue}>
                {indicator.measured === null ? "-" : indicator.measured.toFixed(1)}
              </Text>
              <Text type="body2" className={IndicatorUnit}>
                {indicator.measured === null ? "" : indicator.unit}
              </Text>
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

const IndicatorsWrapper = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* height: 40px; */
  overflow: hidden;
`;

const IndicatorContainer = css`
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 180px;
  height: 40px;
  width: 100%;
  padding: 0 8px;
  border: 1px solid ${color.titanium100};
  background: ${color.titanium50};

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

const IndicatorName = css`
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const IndicatorValueContainer = css`
  display: inline-flex;
  align-items: baseline;
  gap: ${spacings.xxs};
`;

const IndicatorValue = css`
  font-weight: 600;
`;

const IndicatorUnit = css`
  font-weight: 600;
`;

export default IndicatorsDisplay;
